<template>
    <div>
        <Modal width="800px" v-model="modalShow" title="选择交付计划">
            <data-grid v-if="tableShow" ref="leaseClientPick" :columns="colsPick" :queryParams="{}" :autoLoad="false" subListName :dataList="dataList">
                <template #default="{columns, data}">
                    <Table :columns="columns" :data="data" border stripe size="small" highlight-row @on-current-change="onCurrentChange">
                        <template slot-scope="{row}" slot="status">
                            <Tag color="gold" v-if="row.status === 'NORMAL'">正常</Tag>
                            <Tag color="green" v-if="row.status === 'FINISH'">完成</Tag>
                            <Tag color="blue" v-if="row.status === 'TERMINATE'">中止</Tag>
                        </template>
                    </Table>
                </template>
            </data-grid>
            <div slot="footer">
                <Button type="primary" @click="submit">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import tableTitle from 'components/tableTitle/tableTitle.vue'
import dictSelect from '@/components/select/dict-select'
import dataGrid from '@/components/datagrid.vue'
import targetTypeCascader from '@/components/select/targetType-cascader'
import leaseeSelect from '@/components/select/payee-select'



export default {
    components: { tableTitle, dictSelect, dataGrid, targetTypeCascader, leaseeSelect },
    data() {
        return {
            modalShow: false,
            tableShow: false,
            currentData: {},
            dataList: [],
            colsPick: [
                // { title: '订单号', key: 'orderNo' },
                { title: '交付计划编号', key: 'id' },
                { title: '仓库名称', key: 'storageId', dict: ['bizObjects', 'warehouse', true] },
                { title: '租借人', key: 'leaseeId', dict: ['bizObjects', 'member', true] },
                { title: '标的物小类', key: 'targetType', dict: ['target', 'type', true] },
                { title: '标的物编码', key: 'targetCode', dict: ['target', 'code', true] },
                { title: '交付计划总数量', key: 'totalAmount' },
                { title: '已交付数量', key: 'finishAmount' },
                { title: '状态', slot: 'status' },
                { title: '交付方式', key: 'deliveryMethod', dict: ['ENUM_MID-OPERATE-LEASE', 'order.DeliveryMethod'] },]
        }
    },
    methods: {
        openModal(data) {
            this.modalShow = true
            this.getData(data)

        },
        search() {
        },
        onCurrentChange(currentRow) {
            this.currentData = currentRow
            console.log(currentRow)

        },
        getData(queryParams) {
            let data = {
                url: "MID-OPERATE-LEASE/messageService/orderService/queryDeliveryPlans",
                body: {
                    param: queryParams
                }
            }
            this.tableShow = false
            this.invoke(data).then(res => {
                this.dataList = res
                this.tableShow = true
            })

        },
        submit() {
            if (this.currentData.id) {
                this.$emit('onCurrent', this.currentData)
                this.modalShow = false
            } else {
                this.$Message.error('请选择交付计划')
            }
        }
    }

}
</script>

<style lang="scss" scoped>
</style>